module.exports = __webpack_public_path__ + "img/IAFT_Logo.f01abce3.png";